import axios from "axios";
import { checkTokenValidity, refreshToken, logout } from "../helper/auth.js";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_SSO_URL,
  headers: { "content-type": "application/json" },
  paramsSerializer: {},
});

// --- Biến để ngăn vòng lặp refresh token ---
let isRefreshing = false;
let subscribers = [];

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRefreshed(newToken) {
  subscribers.forEach((cb) => cb(newToken));
  subscribers = [];
}

// --- Request Interceptor ---
axiosClient.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// --- Response Interceptor ---
// axiosClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Nếu token hết hạn hoặc API trả 401
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       // Nếu đang refresh → đợi refresh xong
//       if (isRefreshing) {
//         return new Promise((resolve) => {
//           subscribeTokenRefresh((newToken) => {
//             originalRequest.headers.Authorization = `Bearer ${newToken}`;
//             resolve(axiosClient(originalRequest));
//           });
//         });
//       }

//       isRefreshing = true;

//       try {
//         const refreshDone = await refreshToken();
//         if (refreshDone) {
//           const newToken = localStorage.getItem("token");
//           onRefreshed(newToken);
//           originalRequest.headers.Authorization = `Bearer ${newToken}`;
//           return axiosClient(originalRequest);
//         } else {
//           // logout();
//           return Promise.reject(error);
//         }
//       } catch (err) {
//         logout();
//         return Promise.reject(err);
//       } finally {
//         isRefreshing = false;
//       }
//     }

//     return Promise.reject(error);
//   },
// );

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const status = error.response?.status;
    const url = originalRequest?.url || "";

    const isLoginRequest = url.includes("/auth/signin_admin");

    // Login sai thì trả lỗi về trang Login xử lý
    // Không refresh token, không logout
    if (status === 401 && isLoginRequest) {
      return Promise.reject(error);
    }

    // Các API khác bị 401 thì mới xử lý refresh token
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve) => {
          subscribeTokenRefresh((newToken) => {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            resolve(axiosClient(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const refreshDone = await refreshToken();

        if (refreshDone) {
          const newToken = localStorage.getItem("token");
          onRefreshed(newToken);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axiosClient(originalRequest);
        } else {
          logout();
          return Promise.reject(error);
        }
      } catch (err) {
        logout();
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default axiosClient;
